document.addEventListener('DOMContentLoaded', () => {
	const widgets = document.querySelectorAll('.reports-top-regions-text');

	if (!widgets.length) {
		return;
	}

	const regionLabels = {
		'mazowieckie': {
			name: 'Mazowsza',
			prefix: 'z',
		},
		'małopolskie': {
			name: 'Małopolski',
			prefix: 'z',
		},
		'śląskie': {
			name: 'Śląska',
			prefix: 'ze',
		},
		'dolnośląskie': {
			name: 'Dolnego Śląska',
			prefix: 'z',
		},
		'wielkopolskie': {
			name: 'Wielkopolski',
			prefix: 'z',
		},
		'łódzkie': {
			name: 'Łódzkiego',
			prefix: 'z',
		},
		'pomorskie': {
			name: 'Pomorza',
			prefix: 'z',
		},
		'kujawsko-pomorskie': {
			name: 'Kujaw i Pomorza',
			prefix: 'z',
		},
		'zachodniopomorskie': {
			name: 'Pomorza Zachodniego',
			prefix: 'z',
		},
		'lubelskie': {
			name: 'Lubelszczyzny',
			prefix: 'z',
		},
		'warmińsko-mazurskie': {
			name: 'Warmii i Mazur',
			prefix: 'z',
		},
		'lubuskie': {
			name: 'Lubuskiego',
			prefix: 'z',
		},
		'podkarpackie': {
			name: 'Podkarpacia',
			prefix: 'z',
		},
		'podlaskie': {
			name: 'Podlasia',
			prefix: 'z',
		},
		'opolskie': {
			name: 'Opolszczyzny',
			prefix: 'z',
		},
		'świętokrzyskie': {
			name: 'Świętokrzyskiego',
			prefix: 'ze',
		},
	};

	const normalizeRegion = (region) => String(region || '').toLowerCase().trim();

	const getRegionLabel = (region) => {
		const normalizedRegion = normalizeRegion(region);

		return regionLabels[normalizedRegion] || {
			name: region,
			prefix: 'z',
		};
	};

	const buildRegionsText = (regions) => {
		if (!Array.isArray(regions) || !regions.length) {
			return '';
		}

		const topRegions = regions.slice(0, 3).map((item) => getRegionLabel(item.region));

		if (topRegions.length === 1) {
			return `${topRegions[0].prefix} <span>${topRegions[0].name}</span>`;
		}

		if (topRegions.length === 2) {
			return `${topRegions[0].prefix} <span>${topRegions[0].name}</span> oraz ${topRegions[1].prefix} <span>${topRegions[1].name}</span>`;
		}

		return `${topRegions[0].prefix} <span>${topRegions[0].name}</span>, <span>${topRegions[1].name}</span> oraz ${topRegions[2].prefix} <span>${topRegions[2].name}</span>`;
	};

	const updateButtons = (widget, year) => {
		const buttons = widget.querySelectorAll('.reports-top-regions-text__year-button');

		buttons.forEach((button) => {
			button.classList.toggle('is-active', button.dataset.year === year);
		});
	};

	const updateWidget = (widget, summary, year) => {
		const textElement = widget.querySelector('[data-top-regions-text]');

		if (!textElement) {
			return;
		}

		let topRegions;
		let displayYear = year;

		if (!year) {
			// "Wszystkie lata" — aggregate across all years.
			topRegions = getAggregatedTopRegions(summary);
			displayYear = null;
		} else {
			if (!summary[year]) {
				return;
			}

			topRegions = summary[year].topRegions || [];
		}

		const regionsText = buildRegionsText(topRegions);

		if (!regionsText) {
			textElement.innerHTML = '';
			return;
		}

		let rawText = String(widget.dataset.textBeforeRegions || '');

		if (displayYear) {
			rawText = rawText.replace('{year}', displayYear);
		} else {
			rawText = rawText.replace(/\s*w\s+\{year\}\s*r\.?/i, '');
		}

		textElement.innerHTML = `${rawText} ${regionsText}.`;

		updateButtons(widget, year);
	};

	const getAggregatedTopRegions = (summary) => {
		const aggregated = {};

		Object.values(summary).forEach((yearData) => {
			const regions = Array.isArray(yearData.reportsByRegion)
				? yearData.reportsByRegion
				: (yearData.topRegions || []);

			regions.forEach((item) => {
				const key = String(item.region || '').toLowerCase().trim();

				if (!key) {
					return;
				}

				if (!aggregated[key]) {
					aggregated[key] = { region: item.region, count: 0 };
				}

				aggregated[key].count += Number(item.count || 0);
			});
		});

		return Object.values(aggregated)
			.sort((a, b) => b.count - a.count)
			.slice(0, 3);
	};

	widgets.forEach((widget) => {
		let summary = {};

		try {
			summary = JSON.parse(widget.dataset.summary || '{}');
		} catch (error) {
			return;
		}

		const defaultYear = widget.dataset.defaultYear || Object.keys(summary)[0];

		updateWidget(widget, summary, defaultYear);

		const buttons = widget.querySelectorAll('.reports-top-regions-text__year-button');

		buttons.forEach((button) => {
			button.addEventListener('click', () => {
				const year = button.dataset.year;

				if (!year) {
					return;
				}

				updateWidget(widget, summary, year);
			});
		});
	});

	// Sync with the map year-filter buttons.
	document.addEventListener('stop18:year-change', (event) => {
		const year = event.detail?.year ? String(event.detail.year) : null;

		widgets.forEach((widget) => {
			let summary = {};

			try {
				summary = JSON.parse(widget.dataset.summary || '{}');
			} catch (error) {
				return;
			}

			updateWidget(widget, summary, year);
		});
	});
});